<template>
  <div class="swiper-container">
    <div class="swiper-wrapper" @mouseenter="stopAutoplay" @mouseleave="resumeAutoplay">
      <slot></slot>
    </div>
    <div v-if="pagination" ref="pagination" class="fader-pagination" />
    <div
      v-if="arrows"
      ref="prev"
      class="ca-Carousel_IconWrapper appear ca-Carousel_IconWrapperPrev d-none d-lg-block"
    >
      <div class="ca-Carousel_IconContainer">
        <i class="fa fa-angle-left ca-Carousel_Icon-prev"></i>
      </div>
    </div>
    <div
      v-if="arrows"
      ref="next"
      class="ca-Carousel_IconWrapper appear ca-Carousel_IconWrapperNext d-none d-lg-block"
    >
      <div class="ca-Carousel_IconContainer">
        <i class="fa fa-angle-right ca-Carousel_Icon-next"></i>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper/js/swiper.min.js";

export default {
  props: {
    slidesPerView: {
      type: [Number, Object],
      default: 1,
    },
    autoHeight: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: Boolean,
    },
    arrows: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      instance: undefined,
      showNavigation: true,
      loop: false,
      autoplayConfig: this.autoplay
        ? {
            delay: 6000,
          }
        : false,
    };
  },
  mounted() {
    this.instance = this.init();
  },
  beforeDestroy() {
    this.instance.destroy();
  },
  methods: {
    init() {
      if (this.$slots.default) {
        this.addSwiperSlideClass();
        this.loop = this.$slots.default.length > 1;
        return this.initSwiperInstance();
      }
    },
    addSwiperSlideClass() {
      this.$slots.default.forEach(vnode => {
        const element = vnode.elm;
        element.classList.add("swiper-slide");
      });
    },
    initSwiperInstance() {
      let slidesPerView = 1;

      return new Swiper(this.$el, {
        autoHeight: this.autoHeight,
        autoplay: this.autoplayConfig,
        slidesPerView: slidesPerView,
        lazy: {
          loadPrevNext: true,
        },
        loop: this.loop,
        effect: "fade",
        watchOverflow: true,
        pagination: {
          el: this.$refs.pagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.next,
          prevEl: this.$refs.prev,
        },
      });
    },
    stopAutoplay() {
      if (this.autoplay) {
        this.instance.autoplay.stop();
      }
    },
    resumeAutoplay() {
      if (this.autoplay) {
        this.instance.autoplay.start();
      }
    },
  },
};
</script>
<style lang="scss">
@import "~swiper/css/swiper";
@import "~styles/global";

.swiper-button-disabled {
  opacity: 0.5;
  transition: opacity $transition-duration-short;
}

.swiper-button-hidden {
  display: none !important;
}

.swiper-container > .swiper-button-lock {
  display: none !important;
}

.fader-pagination {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 0;
  z-index: $zi-high;

  &.swiper-pagination-bullets {
    bottom: $spacer / 4;

    @media (min-width: $screen-sm-min) {
      bottom: $spacer / 2;
    }
  }
}

.fader-pagination .swiper-pagination-bullet {
  display: block;
  margin: 0 $spacer / 4;
  width: $spacer / 2;
  height: $width-border-medium;
  border-radius: $border-radius;
  background: $white;
  opacity: $opacity-half-visible;

  &:only-child {
    visibility: hidden;
  }

  @media (min-width: $screen-sm-min) {
    width: $spacer;
    height: $width-border-medium;
  }
}

.fader-pagination .swiper-pagination-bullet-active {
  background: $white;
  opacity: 1;
}

.ca-Carousel_IconWrapper {
  position: absolute;
  top: 50%;
  z-index: $zi-lowest;
  transform: translateY(-50%);
  border-radius: 50%;
  border: $width-border-medium solid $white;
  color: $white;
  transition: color $transition-duration, background-color $transition-duration,
    border-color $transition-duration;

  @include hover-states {
    color: $secondary;
    background-color: $white;
    text-decoration: none;
    cursor: pointer;
    border-color: $white;
  }
}

.ca-Carousel_IconContainer {
  display: inline-block;
  font-size: $width-slick-slider-icon / 2;
  line-height: $width-slick-slider-icon;
  width: $width-slick-slider-icon;
  height: $width-slick-slider-icon;
  text-align: center;
  vertical-align: bottom;
}

.ca-Carousel_IconWrapperNext {
  right: $spacer / 2;
}

.ca-Carousel_IconWrapperPrev {
  left: $spacer / 2;
}

.ca-Carousel_Icon-next {
  margin-left: $border-radius;
}

.ca-Carousel_Icon-prev {
  margin-left: -$border-radius;
}
</style>
